<template>
  <div class="carrossel-wizard-stepper">
    <div
      v-for="(step, index) in steps"
      :key="step.id"
      class="carrossel-wizard-stepper__item"
      :class="stepItemClass(step)"
    >
      <div class="carrossel-wizard-stepper__circle">
        <v-icon v-if="isCompleted(step)" small color="white"
          >fas fa-check</v-icon
        >
        <span v-else>{{ step.id }}</span>
      </div>
      <div class="carrossel-wizard-stepper__text">
        <span class="carrossel-wizard-stepper__label">{{ step.label }}</span>
        <span v-if="step.subtitle" class="carrossel-wizard-stepper__subtitle">
          {{ step.subtitle }}
        </span>
      </div>
      <v-icon
        v-if="index < steps.length - 1"
        small
        class="carrossel-wizard-stepper__arrow"
      >
        fas fa-chevron-right
      </v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarrosselWizardStepper",
  props: {
    steps: {
      type: Array,
      required: true
    },
    currentStep: {
      type: Number,
      required: true
    },
    completedSteps: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isCompleted(step) {
      return this.completedSteps.includes(step.id);
    },
    stepItemClass(step) {
      return {
        "carrossel-wizard-stepper__item--active": step.id === this.currentStep,
        "carrossel-wizard-stepper__item--completed": this.isCompleted(step),
        "carrossel-wizard-stepper__item--disabled":
          !step.enabled && step.id !== this.currentStep
      };
    }
  }
};
</script>

<style scoped>
.carrossel-wizard-stepper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
}

.carrossel-wizard-stepper__item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #9e9e9e;
  padding-bottom: 12px;
}

.carrossel-wizard-stepper__item--active {
  color: var(--primary-color, #5870ef);
  border-bottom: 2px solid var(--primary-color, #5870ef);
}

.carrossel-wizard-stepper__item--active .carrossel-wizard-stepper__circle {
  background: var(--primary-color, #5870ef);
  color: #fff;
}

.carrossel-wizard-stepper__item--completed .carrossel-wizard-stepper__circle {
  background: #4caf50;
  color: #fff;
}

.carrossel-wizard-stepper__item--disabled {
  opacity: 0.5;
}

.carrossel-wizard-stepper__circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
}

.carrossel-wizard-stepper__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.carrossel-wizard-stepper__label {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}

.carrossel-wizard-stepper__subtitle {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.3;
  color: #888;
  margin-left: 10px;
  margin-right: 10px;
}

.carrossel-wizard-stepper__item--active .carrossel-wizard-stepper__subtitle {
  color: var(--primary-color, #5870ef);
  opacity: 0.85;
}

.carrossel-wizard-stepper__arrow {
  margin: 0 4px;
  color: #bdbdbd;
  flex-shrink: 0;
}
</style>
